import { mapEventToAppsFlyerEvent } from '@bridebook/web/lib/track-utils/mappers/event-to-appsflyer-event';
import { ITrackingMapper } from '@bridebook/web/lib/track-utils/tracking-mappers';

export const triggeredEnquiryFormMapper: ITrackingMapper<{
  supplierId: string;
  supplierType: string;
  countryCode: string;
}> = ({ event, payload }) => [
  mapEventToAppsFlyerEvent(event),
  {
    af_content_id: payload.supplierId,
    af_country: payload.countryCode,
    af_content_type: payload.supplierType,
  },
];
